module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td><a href="#' +
__e(url) +
'">' +
__e( experienceName ) +
'</a></td><td>' +
__e( lastUpdated ) +
'</td>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/imageLibrary/ImageExperienceItemView.tpl
// module id = 2856
// module chunks = 0